import { v4 as uuidv4 } from 'uuid';

export function MinicartProductList(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'MinicartProductList',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
